import {put, select} from "../../../../shared/SagaService";
import CurrencyActions from "../../../Currency/actions";

export function* readCurrencyRate(currencyCode, date) {
    const targetCurrencyCode = yield select(state => state.Auth.companyCurrencyCode);

    if (!!currencyCode && !!targetCurrencyCode && currencyCode !== targetCurrencyCode) {
        yield put(
            CurrencyActions.readCurrencyRate({
                source_currency_code: currencyCode,
                target_currency_code: targetCurrencyCode,
                date,
            }),
        );
    }
}
